export default "__VITE_ASSET__r5I9wwu$__"